(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7263],{

/***/ 37263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LayoutWidget012": function() { return /* binding */ LayoutWidget012; },
  "default": function() { return /* binding */ LayoutWidget012_LayoutWidget012; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./src/features/widgets/widgets.config.js
var widgets_config = __webpack_require__(52853);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/Item/Item.module.scss
var Item_module = __webpack_require__(97792);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/Item/Item.jsx






var Item = function(param) {
    var title = param.title, slug = param.slug, date = param.date, previewImage = param.previewImage;
    var locale = (0,router.useRouter)().locale;
    var itemDate = (0,react.useMemo)(function() {
        return date;
    }, [
        date
    ]);
    var articleDate = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(itemDate, locale);
    }, [
        locale,
        itemDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
        directory: "news",
        slug: slug,
        className: (Item_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Item_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                    image: previewImage,
                    className: (Item_module_default()).image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Item_module_default()).arrow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (Item_module_default()).icon,
                        name: "arrow_right"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    className: (Item_module_default()).date,
                    color: "grey",
                    uppercase: true,
                    children: articleDate
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    className: (Item_module_default()).title,
                    color: "dark",
                    children: title
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/Item/index.js


// EXTERNAL MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/GridView/GridView.module.scss
var GridView_module = __webpack_require__(76902);
var GridView_module_default = /*#__PURE__*/__webpack_require__.n(GridView_module);
;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/GridView/GridView.jsx







var GridView = function(param) {
    var title = param.title, articles = param.articles;
    var t = (0,translations/* useTranslation */.$)().t;
    var limitedItem = (0,react.useMemo)(function() {
        return articles.slice(0, 3);
    }, [
        articles
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (GridView_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (GridView_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                        className: (GridView_module_default()).title,
                        children: title
                    })
                }),
                limitedItem.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, (0,_object_spread/* default */.Z)({
                        className: (GridView_module_default()).item
                    }, item), item.id);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                    slug: "news",
                    className: (GridView_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (GridView_module_default()).text,
                        color: "dark",
                        uppercase: true,
                        children: t("showAllNews")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var GridView_GridView = ((/* unused pure expression or super */ null && (GridView)));

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/GridView/index.js


// EXTERNAL MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/LayoutWidget012.module.scss
var LayoutWidget012_module = __webpack_require__(81630);
var LayoutWidget012_module_default = /*#__PURE__*/__webpack_require__.n(LayoutWidget012_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/SliderView/SliderView.module.scss
var SliderView_module = __webpack_require__(8922);
var SliderView_module_default = /*#__PURE__*/__webpack_require__.n(SliderView_module);
;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/SliderView/SliderView.jsx









var SliderView = function(param) {
    var title = param.title, articles = param.articles;
    var t = (0,translations/* useTranslation */.$)().t;
    var prevRef = react.useRef(null);
    var nextRef = react.useRef(null);
    var items = (0,react.useMemo)(function() {
        return articles;
    }, [
        articles
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                className: (SliderView_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (SliderView_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (SliderView_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SliderView_module_default())["navigation-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SliderView_module_default())["slider-navigation"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: prevRef,
                                        className: classnames_default()((SliderView_module_default()).navigation, (SliderView_module_default())["navigation-prev"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (SliderView_module_default()).icon,
                                            name: "arrow_slider_prev"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: nextRef,
                                        className: classnames_default()((SliderView_module_default()).navigation, (SliderView_module_default())["navigation-next"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (SliderView_module_default()).icon,
                                            name: "arrow_slider_next"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SliderView_module_default()).slider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
                    prevRef: prevRef,
                    nextRef: nextRef,
                    watchOverflow: true,
                    slidesPerView: "auto",
                    spaceBetween: 4,
                    slidesPerGroup: 1,
                    slidesOffsetAfter: 30,
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (SliderView_module_default()).slide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, (0,_object_spread/* default */.Z)({
                                className: (SliderView_module_default()).item
                            }, item))
                        }, item.id);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
                    slug: "news",
                    className: (SliderView_module_default()).link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (SliderView_module_default()).text,
                        color: "dark",
                        uppercase: true,
                        children: t("showAllNews")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SliderView_SliderView = ((/* unused pure expression or super */ null && (SliderView)));

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/SliderView/index.js


;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget012/LayoutWidget012.jsx









var LayoutWidget012 = function(param) {
    var payload = param.payload;
    var t = (0,translations/* useTranslation */.$)().t;
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("l012", payload.id, widgets_config/* WIDGETS_REGISTRY.LAYOUT-WIDGET */.R["LAYOUT-WIDGET"]);
    var articles = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "articles",
            defaultValue: []
        }, 
    ]).articles;
    var isMobile = (0,ViewMode/* useViewMode */.mJ)().isMobile;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LayoutWidget012_module_default()).wrapper,
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GridView, {
            title: t(title),
            articles: articles
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderView, {
            title: t(title),
            articles: articles
        })
    });
};
/* harmony default export */ var LayoutWidget012_LayoutWidget012 = (LayoutWidget012);


/***/ }),

/***/ 76902:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"GridView_header__dvaWY","title":"GridView_title__iplbF","description":"GridView_description__gkFqL","link":"GridView_link__EpEhm"};

/***/ }),

/***/ 97792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__lB3dg","title":"Item_title__FRXfj","content":"Item_content__D0QVD","date":"Item_date__dHQJG","image":"Item_image__zmLBQ","arrow":"Item_arrow__kf966"};

/***/ }),

/***/ 81630:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget012_wrapper__G4Ptu"};

/***/ }),

/***/ 8922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"SliderView_header__LNQci","title":"SliderView_title__09HDF","description":"SliderView_description__8Qyno","slider":"SliderView_slider__DkO_U","slider-navigation":"SliderView_slider-navigation__R9IyR","position":"SliderView_position__EL9Pu","navigation":"SliderView_navigation__qgKNU","navigation-prev":"SliderView_navigation-prev__4UTcL","navigation-next":"SliderView_navigation-next__iwZMy","slide":"SliderView_slide__FwudA","link":"SliderView_link__wKcyO"};

/***/ })

}]);